import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdMonitoringReportsReportedByUser = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdMonitoringReportsAllMRDs',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      filter: 'ReportedByUser',
    },
  });
  return axios.get(serviceURL, payload);
};
